import type { Actor } from './types';

export const ARVID: Actor = { id: 'arvid', name: 'Arvid' };

export const SARAH: Actor = { id: 'sarah', name: 'Sarah K.' };
export const DAVID: Actor = { id: 'david', name: 'David M.' };
export const EMILY: Actor = { id: 'emily', name: 'Emily R.' };
export const MARIA: Actor = { id: 'maria', name: 'Maria C.' };
export const ALEX: Actor = { id: 'alex', name: 'Alex T.' };
export const PRIYA: Actor = { id: 'priya', name: 'Priya S.' };
export const JONAS: Actor = { id: 'jonas', name: 'Jonas B.' };
export const LISA: Actor = { id: 'lisa', name: 'Lisa W.' };
